import { render } from "./office-model.vue?vue&type=template&id=4ff88ff6"
import script from "./office-model.vue?vue&type=script&lang=js"
export * from "./office-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__